import { Translate } from "react-redux-i18n";
import throwError, { toastPartnerApiFailure } from "../../../comps/errorToast";
import Validator from "../../../comps/validation";
import { RegionEducationMapping } from "../../config/countryEducationMapping";

let g_prop;
export const openManageProfile = () => {
  window.open(window.apcConfig.partner.manage_profile, "_self");
};

export const onGovtSubmitClick = (props) => {
  props.is_saving(true);
  props.connector.submit(props.formStates, props);
};

const questionnaireFieldsToAddError = {
  en_us: ["section_q_0"],
  en_xap: [
    "section_q_0",
    "section_q_3",
    "section_q_5",
    "section_q_6",
    "section_q_7",
    "section_q_8",
  ],
};
export const onSubmitClick = (
  props,
  mapQues,
  countryBasedLang,
  updateError,
  sectionValidation,
) => {
  props.is_saving(true);
  let data;
  if (props.formName == "Education" && !props.isValidated) {
    g_prop = { ...props, mapQues: mapQues, countryBasedLang: countryBasedLang };
    data = convertEducationDataForSubmit(props, mapQues, countryBasedLang);
    props.connector.submit(splzCallBack, data, props);
  } else {
    props.is_saving(false);
    // Show symbolic red color error on fields
    Object.keys(props.allFields.specialization.registeredFields).map(
      (questionKey) => {
        props.touch("specialization", questionKey);
      },
    );
    // Show text error on fields
    var I18n = require("react-redux-i18n").I18n;
    var error = {};
    var throwErrorMessage;
    for (let key in sectionValidation) {
      if (key != "attachment" && key != "section10") {
        throwErrorMessage = "Please fill out all required fields.";
      }
      if (
        questionnaireFieldsToAddError[countryBasedLang] &&
        questionnaireFieldsToAddError[countryBasedLang].indexOf(key) != -1 &&
        !sectionValidation[key]
      ) {
        error[key] = "Error: Please select a value.";
      }
      if (key == "attachment" && !sectionValidation[key]) {
        error.attachment =
          "Error: " + I18n.t("specialization.SplznRequiredAttachmentMsg");
      }
      if (key == "section10" && !sectionValidation[key]) {
        error.section10 =
          "Error: " + I18n.t("specialization.SplznApproveAuthoriseMsg");
      }
      if (
        (props.formStates.email0 &&
          Validator.isEmail(props.formStates.email0) == "invalid") ||
        (props.formStates.email1 &&
          Validator.isEmail(props.formStates.email1) == "invalid")
      ) {
        throwErrorMessage = "Invalid email format.";
        //error.contact = "Error: Invalid email format.";
      } else if (
        (props.formStates.email0 &&
          Validator.isEmailDomain(props.formStates.email0) == "invalid") ||
        (props.formStates.email1 &&
          Validator.isEmailDomain(props.formStates.email1) == "invalid")
      ) {
        throwErrorMessage =
          "The company email domain that you've entered does not match the primary contact's email domain.";
        error.contact =
          "Error: The company email domain that you've entered does not match the primary contact's email domain.";
      } else if (
        props.formStates.email0 &&
        props.formStates.email1 &&
        props.formStates.email0 == props.formStates.email1
      ) {
        throwErrorMessage = I18n.t("specialization.OnbrdGenOnScreenDupEmails");
        error.contact =
          "Error: The below contacts must have unique Email address";
      }
    }
    // Set new error messages and remove old ones.
    updateError(error);
    throwError(throwErrorMessage);
  }
};

export const splzCallBack = (response) => {
  //console.log(response);
  if (response?.saveInProgress === true) {
    setTimeout(
      g_prop.connector.statusCheck,
      5000,
      splzCallBack,
      response?.statusUrl,
    );
  } else {
    onSubmitComplete(response);
  }
};
const onSubmitComplete = (response) => {
  g_prop.is_saving(false);
  if (!response?.saveInProgress && response?.accountId) {
    // To show Thank you page
    g_prop.onClkFinalSubmit(true);
  } else if ("errorCode" in response || response?.isError) {
    toastPartnerApiFailure(response);
  }
};

function isEmpty(str) {
  return !str || str.length === 0;
}

const convertEducationDataForSubmit = (props, mapQues, countryBasedLang) => {
  //console.log(props);
  let data = {};
  data.specialization = "Education";
  data.accountId = props.partnerData.partnerInfo.accountId;
  for (
    let i = 0;
    i < RegionEducationMapping[countryBasedLang].noOfContacts;
    i++
  ) {
    if (!isEmpty(props.formStates["firstName" + i])) {
      data["specializationContact" + i] = {
        firstName: props.formStates["firstName" + i]
          ? props.formStates["firstName" + i]
          : "",
        lastName: props.formStates["lastName" + i]
          ? props.formStates["lastName" + i]
          : "",
        email: props.formStates["email" + i]
          ? props.formStates["email" + i]
          : "",
      };
      if (
        "id" + i in props.formStates &&
        props.formStates["email" + i] === props.formStates["oldEmail" + i]
      ) {
        data["specializationContact" + i]["id"] = props.formStates["id" + i]
          ? props.formStates["id" + i]
          : "";
      }
    }
  }
  data.attachmentDetail = {
    attName: props.formStates.attachmantName,
    contentType: props.formStates.contentType,
    attBody: props.formStates.attachmantBody,
  };
  if (RegionEducationMapping[countryBasedLang].showQuestionnaire) {
    let answers = [];
    for (let key in mapQues) {
      let quesOrder = RegionEducationMapping[
        countryBasedLang
      ].questionNumber.indexOf(parseInt(mapQues[key].questionNumber));
      let anAnswer = {
        questionId: mapQues[key].id,
        questionNumber: mapQues[key].questionNumber,
        question: mapQues[key].question,
      };
      for (let i in RegionEducationMapping[countryBasedLang].answerNameUI[
        quesOrder
      ]) {
        anAnswer[
          RegionEducationMapping[countryBasedLang].answerNameBackend[quesOrder][
            i
          ]
        ] =
          props.formStates[
            RegionEducationMapping[countryBasedLang].answerNameUI[quesOrder][i]
          ];
      }
      let textAreaAnswer = updateTextArea(
        { ...props, countryBasedLang, quesOrder },
        mapQues[key],
        anAnswer,
      );
      if (textAreaAnswer !== undefined) {
        anAnswer.textAreaAnswer = textAreaAnswer;
      }
      answers.push(anAnswer);
    }
    data.splznQuestReq = { answers: answers };
  } else {
    data.splznQuestReq = { answers: [] };
  }
  //console.log(data);
  return data;
};

const updateTextArea = (props, quesDetail, anAnswer) => {
  if (quesDetail.type == "List Input") {
    if (props.formName === "Education") {
      if (props.countryBasedLang === "en_xap") {
        return createTextAreaForSingleQuestion(
          questionsSortOrderFortextArea.Education.en_xap,
          props,
          quesDetail,
          anAnswer,
        );
      } else {
        return createTextAreaForSingleQuestion(
          questionsSortOrderFortextArea.Education.en_us,
          props,
          quesDetail,
          anAnswer,
        );
      }
    }
  }
};

const questionsSortOrderFortextArea = {
  Education: { en_xap: "2", en_us: "3" },
};

const labelSequenceByForm = {
  Education: { 2: [1, 2, 3, 4], 3: [1, 2, 3, 4, 1, 2, 3, 4, 1, 2, 3, 4] },
};

const textAreaAppendPercentByForm = {
  Education: { 2: true },
};

const textAreaNotAppendColonByForm = {
  Education: { 2: true },
};

const createTextAreaForSingleQuestion = (
  labelSequenceSortOrder,
  props,
  quesDetail,
  anAnswer,
) => {
  if (quesDetail.sortOrder === labelSequenceSortOrder) {
    return getLabelAndAnswer(
      labelSequenceSortOrder,
      props,
      quesDetail,
      anAnswer,
    );
  }
};

const getLabelAndAnswer = (
  labelSequenceSortOrder,
  props,
  quesDetail,
  anAnswer,
) => {
  let labelSequence =
    labelSequenceByForm[props.formName][labelSequenceSortOrder];
  let textArea = "";
  for (let i in RegionEducationMapping[props.countryBasedLang]
    .answerNameBackend[props.quesOrder]) {
    textArea +=
      quesDetail["label" + labelSequence[i]] +
      (textAreaNotAppendColonByForm[props.formName][labelSequenceSortOrder]
        ? ""
        : ":") +
      anAnswer[
        RegionEducationMapping[props.countryBasedLang].answerNameBackend[
          props.quesOrder
        ][i]
      ] +
      (textAreaAppendPercentByForm[props.formName][labelSequenceSortOrder]
        ? "%"
        : "") +
      "\n";
  }
  return textArea;
};
